import Blog from "../../../../assets/Blog";
import Chat from "../../../../assets/Chat";
import Dashboard from "../../../../assets/Dashboard";
import Document from "../../../../assets/Document";
import Files from "../../../../assets/Files";
import License from "../../../../assets/License";
import Plan from "../../../../assets/Plan";
import Settings from "../../../../assets/Settings";
import UpgradePlan from "../../../../assets/UpgradePlan";
import PlanDiscount from "../../../../assets/PlanDiscount";
import PaymentType from "../../../../assets/PaymentType";
import BookDemoRequests from "../../../../assets/BookDemoRequests";

export const sidebarData = [
    {
        title: 'Dashboard',
        icon: <Dashboard />,
        url: '/dashboard',
        activeUrl: ['/dashboard', "/"]
    },
    {
        title: "License",
        icon: <License />,
        url: "/license",
        activeUrl: ['/license']
    },
    // {
    //     title: 'Document',
    //     icon: <Document />,
    //     url: '/document',
    //     activeUrl: ['/document', '/documents_trash']
    // },
    {
        title: 'Plans',
        icon: <Plan />,
        url: '/plans',
        activeUrl: ['/plans']
    },
    {
        title: 'Blogs',
        icon: <Blog />,
        url: '/blogs',
        activeUrl: ['/blogs']
    },
    {
        title: 'Upgrade Plan',
        icon: <UpgradePlan />,
        url: '/upgrade_plan',
        activeUrl: ['/upgrade_plan']
    },
    {
        title: 'Plan Discount',
        icon: <PlanDiscount />,
        url: '/plan_discount',
        activeUrl: ['/plan_discount']
    },
    {
        title: 'Payment Type',
        icon: <PaymentType />,
        url: '/payment_type',
        activeUrl: ['/payment_type']
    },
    {
        title: 'Book Demo Requests',
        icon: <BookDemoRequests />,
        url: '/book_demo_request',
        activeUrl: ['/book_demo_request']
    },
    {
        title: 'Settings',
        icon: <Settings />,
        url: '/settings',
        activeUrl: ['/settings']
    },
    // {
    //     title: 'Files',
    //     icon: <Files />,
    //     url: '/files',
    //     activeUrl: ['/files', '/create_files', '/question_answer_flow']
    // },
    // {
    //     title: 'Chat',
    //     icon: <Chat />,
    //     url: '/chat',
    //     activeUrl: ['/chat']
    // },
    // {
    //     title: 'Settings',
    //     icon: <Settings />,
    //     url: '/settings',
    //     activeUrl: ['/settings']
    // },

];
